module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.woff2?59ea9019c9b9bc4d83ab9783e830735c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2
// module id = 0PFe
// module chunks = 29